// src/hooks/api_hooks/useDashboardSummaryQuery.js
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";
import { fetchDashboardSummary } from "../../api/dashboardSummary";

export function useDashboardSummaryQuery(reactQueryOptions = {}) {
  const auth = useAuth();

  const token = auth?.user?.access_token ?? null;
  const isAuthenticated = auth?.isAuthenticated;
  const isSilent = auth?.activeNavigator === "signinSilent";
  const logoutInProgress =
    typeof window !== "undefined" &&
    sessionStorage.getItem("logoutInProgress") === "1";

  return useQuery({
    queryKey: ["dashboard-summary"],

    queryFn: () => fetchDashboardSummary(token, { isSilent }),

    enabled: Boolean(
      isAuthenticated && token && !logoutInProgress && !isSilent,
    ),

    retry: (failureCount, error) => {
      if (error?.message === "unauthorized") return false;
      return failureCount < 2;
    },

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 0, // ← was 60_000
    gcTime: 0, // ← was 120_000

    ...reactQueryOptions,
  });
}
